import { render, staticRenderFns } from "./TrademarkModels.vue?vue&type=template&id=39639d56"
import script from "./TrademarkModels.vue?vue&type=script&lang=js"
export * from "./TrademarkModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports